import "./style/index.css?global";
import { Select } from "antd";

// @ts-ignore
Select.defaultProps = {
  listItemHeight: 32
};
export default Select;